(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();
  ready(() => {
    document.body.classList.add('etsy-preview-page');
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex,follow';
    document.head.appendChild(robots);
    const customizer = document.querySelector('etsy-framed-text-customizer');
    const download = document.querySelector('[data-download-preview]');
    const returnButton = document.querySelector('[data-return-etsy]');
    if (!customizer || !download) return;

    const saveBlob = (blob, enteredText) => {
      if (!blob) throw new Error('The preview image could not be generated.');
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const clean = enteredText.trim().replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').slice(0, 40) || 'framed-text';
      link.href = url;
      link.download = `honest-ice-framed-text-${clean}.png`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1200);
    };

    download.addEventListener('click', async () => {
      const input = customizer.querySelector('.framed-text__input');
      const error = customizer.querySelector('.ice-customizer__error');
      const canvas = customizer.querySelector('canvas');
      const enteredText = (input?.value || '').trim();
      if (!canvas || !enteredText) {
        if (error) { error.hidden = false; error.textContent = 'Enter your text before downloading the preview.'; }
        input?.focus();
        return;
      }
      download.disabled = true;
      download.innerHTML = '<span>•</span> Preparing image…';
      try {
        customizer.querySelector('[data-ice-view="top"]')?.click();
        await new Promise(resolve => setTimeout(resolve, 180));
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
        saveBlob(blob, enteredText);
        if (error) { error.textContent = ''; error.hidden = true; }
      } catch (err) {
        if (error) { error.hidden = false; error.textContent = err.message || 'The preview image could not be downloaded.'; }
      } finally {
        download.disabled = false;
        download.innerHTML = '<span>↓</span> Download preview image';
      }
    });

    returnButton?.addEventListener('click', () => {
      location.href = 'https://www.etsy.com/listing/1413153429/custom-initial-ice-mold-framed-letter';
    });
  });
})();
